import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api_middleware";

// Fetch all behavior configs
export const fetchAllBehaviorConfigs = createAsyncThunk(
  "behaviorConfigs/fetchAllBehaviorConfigs",
  async () => {
    const response = await api(`v1/admin/behavior-configs/`, "GET");
    return response;
  }
);

// Fetch a single behavior config by ID
export const fetchBehaviorConfig = createAsyncThunk(
  "behaviorConfigs/fetchBehaviorConfig",
  async (behaviorConfigId: string) => {
    const response = await api(`v1/admin/behavior-configs/${behaviorConfigId}`, "GET");
    return response;
  }
);

// Create a new behavior config
export interface CreateBehaviorConfigParams {
  behavior_name: string;
  demo_mode?: string;
}

export const createBehaviorConfig = createAsyncThunk(
  "behaviorConfigs/createBehaviorConfig",
  async (params: CreateBehaviorConfigParams) => {
    const response = await api(`v1/admin/behavior-configs/`, "POST", params);
    return response;
  }
);

// Update a behavior config
export interface UpdateBehaviorConfigParams {
  id: string;
  behavior_name?: string;
  demo_mode?: string | null;
}

export const updateBehaviorConfig = createAsyncThunk(
  "behaviorConfigs/updateBehaviorConfig",
  async (params: UpdateBehaviorConfigParams) => {
    const { id, ...updateData } = params;
    const response = await api(`v1/admin/behavior-configs/${id}`, "PUT", updateData);
    return response;
  }
);
